/* eslint-disable no-useless-escape */
function getRawUrlParameter(name: string): string {
  const cleanname = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${cleanname}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : results[1];
}

function getUrlParameter(name: string): string {
  const result = getRawUrlParameter(name);
  return decodeURIComponent(result.replace(/\+/g, ' '));
}

function getLastPartOfUrl(): string {
  var lastPart = window.location.href.substr(
    window.location.href.lastIndexOf('/') + 1
  );
  return lastPart;
}
/* eslint-enable no-useless-escape */
export { getRawUrlParameter, getUrlParameter, getLastPartOfUrl };
